import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GtmService } from '../../../../core/services/gtm.service';
import { SeoService } from '../../../services/seo.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-terms-conditions',
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    ReactiveFormsModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './terms-conditions.html',
  styleUrl: './terms-conditions.scss',
})
export class TermsConditionsComponent implements OnInit {
  platformId = inject(PLATFORM_ID);
  private gtm = inject(GtmService);
  private seo = inject(SeoService);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0;
      this.gtm.pageView({
        page_path: '/terms',
        page_title: 'Horizinns | Terms and Conditions'
      });
    }
    this.seo.updateMetaTags(
      'Terms and Conditions',
      'Terms and Conditions for Horizinns',
      undefined,
      `${environment.appUrl}/terms`
    );
  }
}
